import {useApi} from "./useApi";
import {useCallback, useState} from "react";
import {useNotify} from "./system/useNotify";
import {dispatcher} from "../store";
import {useStoreSelector} from "./redux/useStoreSelector";
import {Client} from "../api/api";
import _ from "lodash";

const LIMIT = 1000

export function useClients() {
  const clients = useStoreSelector( s => s.clients.list)
  const {api, isAuth} = useApi(),
    {addNotify, handleApiError} = useNotify(),
    [page, setPage] = useState<number>(0)

  const loadClients = useCallback(async (page: number = 0, query: string = '') => {
    if (isAuth) {
      await api.getClients({limit: LIMIT, offset: page * LIMIT, query})
          .then(handleApiError)
          .then(dispatcher.clients.setList)
          .catch(e => addNotify('error', 'Error', e.message))
    }
  }, [addNotify, api, handleApiError, isAuth])

  const loadClientsAll = useCallback((query: string = '') => {
    isAuth && api.getClients({limit: 10000, offset: 0, query})
      .then(handleApiError)
      .then(dispatcher.clients.setList)
      .catch(e => addNotify('error', 'Error', e.message))
  }, [addNotify, api, handleApiError, isAuth])


  const moreClients = useCallback(async (query: string = '') => {
    await (isAuth && api.getClients({limit: LIMIT, offset: page * LIMIT, query})
        .then(handleApiError)
        .then(dispatcher.clients.addList)
        .catch(e => addNotify('error', 'Error', e.message)))
    setPage(page+1)
  }, [addNotify, api, handleApiError, isAuth, page])

  const loadClientById = useCallback(async (id: number): Promise<Client|undefined> => {
    if (isAuth) {
      const find = _.find(clients, {id});
      if (!find) {
        const res = await api.getClientsById({id});
        if (res.status === 200) {
          dispatcher.clients.addClient(res.body);
          return res.body
        }
      } else {
        return find
      }
    }
  }, [api, clients, isAuth])

  return {clients, loadClients, moreClients, loadClientById, loadClientsAll}
}
